module.exports = __webpack_public_path__ + "assets/images/10-35q8n0v.jpg";